export enum SortDir {
  ASC = 'ASC',
  DESC = 'DESC',
}
